module.exports = __webpack_public_path__ + "static/media/login-banner.11530e5c.jpg";